<template>
  <b-row>
    <b-col cols="12">
      <b-form-select 
        v-model="switchFilter" 
        :options="options"
        @change="clean()"
      > 
        <template #first>
          <b-form-select-option :value="null" disabled>-- Escolha marca ou departamento --</b-form-select-option>
        </template>

      </b-form-select>
    </b-col>
    
    <b-col v-if="switchFilter == 'departaments'" cols="4" class="mt-4">
      <SelectItems
        v-model="fields.departments1"
        label="name"
        :items="departments1"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments1 = ''"
        :reduceFunction="(departments1) => departments1"
        placeholder="Selecione o departamento desejado"
      />
      <error-message :errorMessage="errorMessages.departments1" />
    </b-col>

    <b-col
      cols="4"
      class="mt-4"
      v-if="switchFilter == 'departaments' && fields.departments1 && departments2.length && fields.departments1.link == 0"
      >
      <SelectItems
        label="name"
        v-model="fields.departments2"
        :disabled="!fields.departments1"
        :items="departments2"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments2 = ''"
        :reduceFunction="(departments2) => departments2"
        placeholder="Selecione a categoria"
      />
      <error-message :errorMessage="errorMessages.departments2" />
    </b-col>

    <b-col 
      cols="4" 
      class="mt-4" 
      v-if="switchFilter == 'departaments' && fields.departments2 && departments3.length && fields.departments2.link == 0"
    >
      <SelectItems
        label="name"
        v-model="fields.departments3"
        :disabled="!fields.departments2 || !!families.length"
        :items="departments3"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments3 = ''"
        :reduceFunction="(departments3) => departments3"
        placeholder="Selecione a 1ª subcategoria desejada"
      />
      <error-message :errorMessage="errorMessages.departments3" />
    </b-col>

    <b-col
      cols="4"
      class="mt-4"
      v-if="switchFilter == 'departaments' && fields.departments3 && departments4.length && fields.departments3.link == 0"
    >
      <SelectItems
        label="name"
        v-model="fields.departments4"
        :items="departments4"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments4 = ''"
        :reduceFunction="(departments4) => departments4"
        placeholder="Selecione a 2ª subcategoria desejada"
      />
      <error-message :errorMessage="errorMessages.departments4" />
    </b-col>

    <b-col
      cols="4"
      class="mt-4"
      v-if="switchFilter == 'departaments' && fields.departments4 && departments5.length  && fields.departments4.link == 0"
    >
      <SelectItems
        label="name"
        v-model="fields.departments5"
        :items="departments5"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments5 = ''"
        :reduceFunction="(departments5) => departments5"
        placeholder="Selecione a 3ª subcategoria desejada"
      />
      <error-message :errorMessage="errorMessages.departments5" />
    </b-col>

    <b-col 
      cols="4" 
      class="mt-4" 
      v-if="switchFilter == 'departaments' && fields.departments5 && departments6.length  && fields.departments5.link == 0"
    >
      <SelectItems
        label="name"
        v-model="fields.departments6"
        :items="departments6"
        :loading="loadingDepartments"
        @update:value="errorMessages.departments6 = ''"
        :reduceFunction="(departments6) => departments6"
        placeholder="Selecione a 4ª subcategoria desejada"
      />
      <error-message :errorMessage="errorMessages.departments6" />
    </b-col>

    <b-col v-if="switchFilter == 'brand'" cols="12" class="mt-4">
      <!-- //?Selecione a marca desejada -->
      <SelectItems
        label="marca"
        v-model="fields.brand"
        :items="brand"
        :loading="loadingDepartments"
        @update:value="errorMessages.brand = ''"
        :reduceFunction="(brand) => brand"
        placeholder="Selecione a marca desejada"
      />
      <error-message :errorMessage="errorMessages.brand" />
    </b-col>

    <b-col cols="12" class="text-center mt-4" v-if="loadingFamilies">
      <b-spinner small type="grow"></b-spinner>
      Carregando famílias de produtos...
    </b-col>

    <b-col cols="12" class="mt-4" v-if="!loadingFamilies && families.length">
      <SelectItems
        label="name"
        v-model="fields.family"
        :items="families"
        :loading="loadingDepartments"
        @update:value="errorMessages.family = ''"
        :reduceFunction="(family) => family.familyId"
        placeholder="Selecione a família de produtos desejada"
      />
      <error-message :errorMessage="errorMessages.family" />
    </b-col>

    <b-col cols="12" class="mt-4">
      <input
      @keyup.enter="search()"
        type="text"
        class="form-control"
        v-model="fields.name"
        placeholder="Nome do produto, código de barras, marca"
      />
    </b-col>

    <b-col cols="12" class="mt-4">
      <b-button
        variant="success"
        @click="search()"
        :disabled="externalLoading"
      >
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
      
      <b-button variant="warning" class="ml-2" @click="clean()">
        <i class="fas fa-trash mr-2"></i>
        Limpar
      </b-button>
    </b-col>

  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import ErrorMessage from 'Components/ErrorMessage.vue';
import SelectItems from '../../../components/Inputs/SelectItems.vue';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ProductsFilter',
  emits: ['searchProductsByFamilyId'],
  components: { SelectItems, ErrorMessage },
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    externalLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingDepartments: false,
      loadingFamilies: false,
      link: 0,
      linksAtivos: [],
      switchFilter: null,
      fields: {
        name: '',
        departments1: '',
        departments2: '',
        departments3: '',
        departments4: '',
        departments5: '',
        departments6: '',
        subCategory4: '',
        family: '',
        brand: '',
      },
      departments1: [],
      departments2: [],
      departments3: [],
      departments4: [],
      departments5: [],
      departments6: [],
      subCategories4: [],
      families: [],
      brand: [],
      options: [
        { value: 'departaments', text: 'Departamento' },
        { value: 'brand', text: 'Marca' },
      ],
      errorMessages: {
        department: '',
        brand: '',
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario'])
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.fields = this.value || {};
      },
    },
    fields: {
      deep: true,
      handler() {
        this.$emit('update:value', this.fields);
      },
    },
    'fields.departments1': function () {
      this.families = [];
      this.fields.departments2 = '';

      if(this.fields.departments1.link == 1) {
        this.fields.family = this.fields.departments1.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments1.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments1, 'departments2');
    },
    'fields.departments2': function () {
      this.families = [];
      this.fields.departments3 = '';

      this.fields.tipo = this.fields.departments2.tipo;

      if(this.fields.departments2.link == 1) {
        this.fields.family = this.fields.departments2.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments2.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments2, 'departments3');
    },
    'fields.departments3': function () {
      this.families = [];
      this.fields.departments4 = '';

      if(this.fields.departments3.link == 1) {
        this.fields.family = this.fields.departments3.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments3.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments3, 'departments4');
    },
    'fields.departments4': function () {
      this.families = [];
      this.fields.departments5 = '';

      if(this.fields.departments4.link == 1) {
        this.fields.family = this.fields.departments4.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments4.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments4, 'departments5');
    },
    'fields.departments5': function () {
      this.families = [];
      this.fields.departments6 = '';

      if(this.fields.departments5.link == 1) {
        this.fields.family = this.fields.departments5.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments5.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments5, 'departments6');
    },
    'fields.departments6': function () {
      this.families = [];
      this.fields.departments7 = '';

      if(this.fields.departments6.link == 1 && this.fields.departments6.link != null) {
        this.fields.family = this.fields.departments6.departmentId
        this.$emit('searchProductsByFamilyId', this.fields.departments6.departmentId);
        return;
      }

      this.listDepartments(this.fields.departments6, 'departments7');
    },
    'fields.family': function () {
      this.$emit('searchProductsByFamilyId', this.fields.family);
    },
    'fields.brand': function () {
      this.$emit('searchProductsByFamilyId', this.fields.brand.marca);
    },
  },
  mounted() {
    const data = {
      departmentId: 0,
      tipo: "geral"
    }
    this.getBrand();

    this.listDepartments(data, 'departments1');
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getDepartmentsCombo',
      'getDepartments',
      'getCategories',
      'getChildDepartments',
      'getFamiliesByDepartmentId',
      'getAllBrand',
    ]),
    search() {
      this.$emit('searchProductsByFamilyId', this.fields.family);
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    listDepartments(data, arrayToPopulate) {
      if (data.departmentId !== 0 && !data.departmentId) return;

      data.lojistaId = this.userTypeId();
      this.loadingDepartments = true;
console.log(data);
      this.getChildDepartments(data)
        .then((response) => {
          const departments = response.data.data || [];

          if (departments.length === 0) {
            this.listFamilies(data.departmentId);
            return;
          }
          
          this.$set(this, arrayToPopulate, departments || []);
        })
        .finally(() => {
          this.loadingDepartments = false;
        });
    },
    async listFamilies(departmentId) {
      this.loadingFamilies = true;

      this.getFamiliesByDepartmentId(departmentId)
        .then((response) => {
          this.families = response.data.data || [];
        })
        .finally(() => {
          this.loadingFamilies = false;
        });
    },
    clean() {
      this.errorMessages = {};
      this.fields = {
        name: '',
        departments1: '',
        departments2: '',
        departments3: '',
        departments4: '',
        departments5: '',
        departments6: '',
        subCategory4: '',
        family: '',
        brand: '',
        switchFilter: null,
      };
      this.departments2 = [];
      this.departments3 = [];
      this.departments4 = [];
      this.departments5 = [];
      this.departments6 = [];
      this.subCategories4 = [];
      this.families = [];
      setTimeout(() => {
        this.$emit('searchProductsByFamilyId', 0);
      }, 10)
    },
    getBrand(){
      this.getAllBrand()
        .then((response) => {
          this.brand = response.data.data;
        })
        .finally(() => {
          this.loadingDepartments = false;
        });
    },
  },
};
</script>